import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wchx4fhhck: FaireBrandEntity = {
  token: "b_wchx4fhhck",
  type: "brand",
  name: "Ersa Fibers",
  avatarUrl:
    "https://cdn.faire.com/fastly/3373cb07c854c1f2f9ac122501005aa4c1ff3fa487055bac70070ba9442fb1fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3bc9734f439fe9829ae5db9b99d430554e6060198bca0ba9ded52761effc33c7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3373cb07c854c1f2f9ac122501005aa4c1ff3fa487055bac70070ba9442fb1fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3bc9734f439fe9829ae5db9b99d430554e6060198bca0ba9ded52761effc33c7.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Ersa Fibers is a one women studio located in Portland, Oregon. Everything’s designed, cut, and sewn by hand. In a conscious effort to reduce waste, everything is made to order, and any remaining scraps are upcycled into one-of-a-kind products. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:51.072Z",
    importedBy: "entity-db-cli",
  },
};
